import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { ListGroup, Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import { isBrowser } from 'react-device-detect';
import { conditionType } from 'utils/types';

const ConditionBody = () => {
  return (
    <ListGroup variant="flush" className="w-100" style={{ borderBottom: '0' }}>
      <ListGroup.Item>
        <div>
          <strong>{conditionType.SehrGut}</strong>
        </div>
        <div>
          Ich habe, wenn überhaupt, so minimale Gebrauchsspuren, dass ich als
          „ungetragen“ durchgehen könnte.
        </div>
      </ListGroup.Item>
      <ListGroup.Item>
        <div>
          <strong>{conditionType.Gut}</strong>
        </div>
        <div>
          Ich habe minimale Gebrauchsspuren, wie z. B. leichter Formverzug vom
          Waschen, minimales Waschpilling o. Ä.
        </div>
      </ListGroup.Item>
      <ListGroup.Item>
        <div>
          <strong>{conditionType.Geliebt}</strong>
        </div>
        <div>
          Ich wurde getragen, bespielt und geliebt, habe aber trotzdem keine
          Löcher oder Flecken. Leichter Knieabrieb, Waschpilling oder Risse im
          Druck können mich auszeichnen.
        </div>
      </ListGroup.Item>
    </ListGroup>
  );
};

function popoverCondition() {
  return (
    <Popover id="popover-condition">
      <Popover.Header as="h3">Zustand</Popover.Header>
      <Popover.Body className="p-0">
        <ConditionBody />
      </Popover.Body>
    </Popover>
  );
}

function ConditionModal(props) {
  return (
    <Modal
      {...props}
      centered
      size="md"
      backdropClassName="condition-modal-backdrop"
    >
      <Modal.Header closeButton style={{ backgroundColor: '#e9ecef' }}>
        <Modal.Title>Zustand</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <ConditionBody />
      </Modal.Body>
    </Modal>
  );
}

const ConditionsInfo = () => {
  const [showConditionModal, setShowConditionModal] = useState(false);

  return (
    <>
      <ConditionModal
        show={showConditionModal}
        onHide={() => setShowConditionModal(false)}
      />
      {isBrowser ? (
        <OverlayTrigger overlay={popoverCondition()} placement={'right'}>
          <FontAwesomeIcon icon="circle-info" />
        </OverlayTrigger>
      ) : (
        <span onClick={() => setShowConditionModal(true)}>
          <FontAwesomeIcon icon="circle-info" />
        </span>
      )}
    </>
  );
};

export default ConditionsInfo;
